export enum ApplicableParagraphEnum {
  SIRM1a = 'SIRM1a',
  SIRM1b = 'SIRM1b',
  SIRM1c = 'SIRM1c',
  SIRM1d = 'SIRM1d',
}
